import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Router, ActivatedRoute } from '@angular/router';
// import { default as swal } from 'sweetalert2';
import { environment } from '../environments/environment';
// import { SocketService } from './socket.service';
import { BehaviorSubject } from 'rxjs';
import { Observable, of } from 'rxjs';
import { StorageService } from './storage.service';

// import { Observable,Observer } from 'rxjs';
// import * as socketIo from 'socket.io-client';
// import { Socket} from './interfaces';
// import { tokenNotExpired } from 'angular2-jwt';
declare var toastr, $, download, notifier;
var authToken;
var options;
@Injectable()
export class AuthService {
	domain = environment.apiURL;
	// mockDomain = environment.mockApiUrl;

	private simpleVar: any = 0;
	private $BehaveObs: BehaviorSubject<any>;

	// , private socket: SocketService
	constructor(
		private storage: StorageService,
		private http: HttpClient,
		private router: Router
	) {
		this.$BehaveObs = new BehaviorSubject(this.simpleVar);
	}

	//#region Authentication
	createAuthenticationHeaders() {
		let uri = window.location.search;
		if (window.location.href.includes('mapview')) {
			return {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					authorization:
						'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6eyJwZXJtaXNzaW9uIjp7ImNyZWF0ZUFkbWluIjpmYWxzZSwibGFuZU9ubHkiOmZhbHNlLCJjcmVhdGVCYXNlIjpmYWxzZSwiY3JlYXRlR3JpZCI6ZmFsc2UsInJlcG9ydHMiOnRydWUsImFkZExvY2F0aW9uIjpmYWxzZSwiZWRpdEFkbWluIjpmYWxzZSwidmlld0FkbWluIjp0cnVlLCJjcmVhdGVTdWJBZG1pbiI6dHJ1ZSwiZWRpdFN1YkFkbWluIjp0cnVlLCJjcmVhdGVTdWJBZG1pblVzZXJzIjp0cnVlLCJlZGl0U3ViQWRtaW5Vc2VycyI6dHJ1ZSwibWFwVmlldyI6dHJ1ZSwiY29udGFpbmVyU3RhdHVzRGFzaGJvYXJkIjp0cnVlLCJ1cGxvYWRDb250YWluZXJzIjp0cnVlLCJlZGl0Q29udGFpbmVycyI6dHJ1ZSwibm90aWZpY2F0aW9uU2V0dGluZyI6dHJ1ZSwiYW5hbHl0aWNzIjp0cnVlLCJlcXVpcG1lbnRBbGxvY2F0aW9uIjp0cnVlLCJlZGl0RXF1aXBtZW50Ijp0cnVlLCJsYW5lQWxsb2NhdGlvbiI6dHJ1ZSwiY3JlYXRlR2F0ZXMiOnRydWUsImVkaXRHYXRlcyI6dHJ1ZSwiY3JlYXRlVXNlcnNHYXRlIjp0cnVlLCJlZGl0VXNlcnNHYXRlIjp0cnVlLCJhZGRBc3NldCI6dHJ1ZSwiZWRpdEFzc2V0Ijp0cnVlLCJjcmVhdGVVc2Vyc1lhcmQiOnRydWUsImVkaXRVc2Vyc1lhcmQiOnRydWUsImNyZWF0ZVVzZXJzQ3JhbmUiOnRydWUsImVkaXRVc2Vyc0NyYW5lIjp0cnVlLCJzd2l0Y2hKb2JzIjpmYWxzZSwibWFudWFsQWRkcmVzcyI6ZmFsc2UsIm1hcE9wZXJhdG9yIjpmYWxzZSwic2VhcmNoQ29udGFpbmVyIjpmYWxzZSwiYXV0b21hdGljWWFyZCI6ZmFsc2UsImFjY2VwdFRhc2siOmZhbHNlLCJhdXRvbWF0aWNDcmFuZSI6ZmFsc2UsInJlamVjdFRhc2siOmZhbHNlLCJlbXB0eVRyYWlsZXJFZGl0IjpmYWxzZSwiYWxsb2NHYXRlIjpmYWxzZSwiY3JlYXRlQ0hBSm9iIjpmYWxzZSwidmlld0NIQUpvYiI6ZmFsc2UsInZpZXdIZWF0TWFwIjp0cnVlLCJkb3dubG9hZCI6dHJ1ZSwidmlld0Fzc2V0Ijp0cnVlLCJhZGRsb2NhdGlvbiI6dHJ1ZSwiam9icyI6dHJ1ZSwiaGVpZ2h0U2hpZnRpbmciOnRydWUsImdyaWRTaGlmdGluZyI6dHJ1ZX0sIl9pZCI6IjYyNGU4NTNiMjE2ODY3NjIzYWFmMDY3OSIsImVtYWlsIjoiZGVtb0BseW5raXQuaW4iLCJtb2JpbGUiOiI5MjQwMjkyMDA5IiwiZGVwb3ROYW1lIjpbIkxhbmRtYXJrIENGUyJdLCJkZXBvdElEIjpbIjYwZDg4NjgwNTIwNGM0MzY2NGEzYjgwOCJdLCJwb3NpdGlvbiI6W10sInVzZXJUeXBlIjoiYWRtaW4iLCJuYW1lIjoiTHlua2l0IEFkbWluIiwic3RhdHVzIjoiQSIsImlzQXBwcm92ZWQiOnRydWUsInNlc3Npb25LZXkiOiIxNjc1ODM5MTA4NzQ3XzYyNGU4NTNiMjE2ODY3NjIzYWFmMDY3OV9kZW1vQGx5bmtpdC5pbiJ9LCJpYXQiOjE2NzU4MzkxMDgsImV4cCI6MTczODk1MzAxMn0.TFGQSNcHn5PlJSsID2nOnZyunGZhIP8vgQRWzS-qe9w',
					agent: 'web'
				})
			};
		} else if (window.location.href.includes('focusview')) {
			var url = decodeURI(uri.split('&')[4].replace('=', ':'));

			if (url.includes('token')) {
				url = url.replace('token:', '');
			}

			// console.log(url);

			return {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					authorization: url,
					agent: 'web'
				})
			};
		}
		return {
			// environment.sso_token
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				authorization: localStorage.getItem(environment.auth_token),
				agent: 'web'
			})
		};
	}

	login(details) {
		return this.http.post(`${this.domain}/user/login`, details);
		// return this.http.post(`${this.domain}/login`, details)
	}

	forgetPassword(details) {
		details.bgColor = `#FF5722`;
		return this.http.post(`${this.domain}/user/forgetPassword`, details);
	}

	logout() {
		// let token;
		// // if (localStorage.getItem('chat')) {
		// //   localStorage.removeItem('chat');
		// // }
		// if (localStorage.getItem(environment.auth_token)) {
		//   token = JSON.parse(atob((localStorage.getItem(environment.auth_token)).split('.')[1])).token;
		//   // console.log("logout session key", token.sessionKey);
		//   // this.socket.logout(token._id, token.sessionKey)

		// }
		authToken = null;
		localStorage.removeItem(environment.auth_token);
		localStorage.removeItem(environment.tokenName);
		this.router.navigate(['/login']);
	}

	changePassword(details) {
		return this.http.post(
			`${this.domain}/user/changePassword`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	checkEncryptedString(details) {
		return this.http.post(`${this.domain}/user/checkEncryptedString`, details);
	}

	setDefaultTheme(details) {
		return this.http.post(
			`${this.domain}/user/setDefaultTheme`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getUserData(details) {
		return this.http.post(
			`${this.domain}/user/getUserDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllUsers(details) {
		return this.http.post(
			`${this.domain}/user/getAllUsers`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	updateUser(details) {
		return this.http.post(
			`${this.domain}/user/updateUser`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setDefaultPage(details) {
		return this.http.post(
			`${this.domain}/user/setDefaultPage`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setDefaultDataMode(details) {
		return this.http.post(
			`${this.domain}/user/setDefaultDataMode`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setNewPassword(details) {
		return this.http.post(`${this.domain}/user/setNewPassword`, details);
	}

	getLocation(details) {
		return this.http.post(
			`${this.domain}redis/getLocation`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	query(details) {
		return this.http.post(
			`${this.domain}query`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	// #endregion Authentication

	//#region Admin

	//#endregion Admin

	//#region users

	getUsers(details) {
		return this.http.post(
			`${this.domain}/user/getAllUsers`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	createUser(details) {
		return this.http.post(
			`${this.domain}/user/addUser`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	editUser(details) {
		return this.http.post(
			`${this.domain + details.path}`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	updateUserStatus(details) {
		return this.http.post(
			`${this.domain}/user/changeStatus`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	deleteUser(details) {
		return this.http.post(
			`${this.domain}/user/deleteUser`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getUserForLane(details) {
		return this.http.post(
			`${this.domain}/user/getUserForLane`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	addOrganization(details) {
		return this.http.post(
			`${this.domain}/organization/addOrganization`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getOrganizationDetails(details) {
		return this.http.post(
			`${this.domain}/organization/getOrganizationDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllOrganizations(details) {
		return this.http.post(
			`${this.domain}/organization/getAllOrganizations`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	editOrganization(details) {
		return this.http.post(
			`${this.domain}/organization/editOrganization`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	deleteOrganization(details) {
		return this.http.post(
			`${this.domain}/organization/deleteOrganization`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion users

	//#region Blogs
	saveBlog(details) {
		return this.http.post(
			`${this.domain}/blog/saveBlogDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getBlogs(details) {
		return this.http.post(
			`${this.domain}/blog/getAllBlogs`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	deleteBlog(details) {
		return this.http.post(
			`${this.domain}/blog/deleteBlog`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	uploadImage(details) {
		return this.http.post(
			`${this.domain}/blog/uploadImage`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getImage(details) {
		return this.http.post(
			`${this.domain}/blog/getImage`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	//#endregion Blogs

	//#region Payment

	getPriceDetails(obj) {
		return this.http.post(
			`${this.domain}/price/getPriceDetails`,
			obj,
			this.createAuthenticationHeaders()
		);
	}

	createPaymentOrder(obj) {
		return this.http.post(
			`${this.domain}/payment/createPaymentOrder`,
			obj,
			this.createAuthenticationHeaders()
		);
	}

	verifyPayment(obj) {
		return this.http.post(
			`${this.domain}/payment/verifyPayment`,
			obj,
			this.createAuthenticationHeaders()
		);
	}

	verifyInstantPayment(obj) {
		return this.http.post(
			`${this.domain}/payment/verifyInstantPayment`,
			obj,
			this.createAuthenticationHeaders()
		);
	}

	deductBalance(obj) {
		return this.http.post(
			`${this.domain}/payment/deductBalance`,
			obj,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion Payment

	//#region Containers

	set setData(containerDetails) {
		this.simpleVar = containerDetails;
		this.$BehaveObs.next(containerDetails);
	}

	get getData(): Observable<any> {
		return this.$BehaveObs.asObservable();
	}

	//#region Analytics

	getCountOfUserStatus(details) {
		return this.http.post(
			`${this.domain}/analytics/getUserAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getLaneAnalytics(details) {
		return this.http.post(
			`${this.domain}/analytics/getLaneAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getSpotRate(details) {
		return this.http.post(
			`${this.domain}/analytics/getSpotRate`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	fetchCandleStickRates(details) {
		return this.http.post(
			`${this.domain}/analytics/fetchCandleStickRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getStepRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getStepRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getSeaRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getSeaRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getBuySellGraphData(details) {
		return this.http.post(
			`${this.domain}/analytics/getBuySellGraphData`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllCarriers(details) {
		return this.http.post(
			`${this.domain}/analytics/getAllCarriers`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCarrierRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getCarrierRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getMarketRateAnalytics(details) {
		return this.http.post(
			`${this.domain}/analytics/getMarketRateAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getMarketPulse(details) {
		return this.http.post(
			`${this.domain}/analytics/getMarketPulse`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getPortsAnalytics(details) {
		return this.http.post(
			`${this.domain}/analytics/getPortsAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getVolumePeerRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getVolumePeerRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getIndustryPeerRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getIndustryPeerRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getLaneTopMovers(details) {
		return this.http.post(
			`${this.domain}/analytics/getLaneTopMovers`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getLaneIndex(details) {
		return this.http.post(
			`${this.domain}/analytics/getLaneIndex`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getLaneIndexCurve(details) {
		return this.http.post(
			`${this.domain}/analytics/getLaneIndexCurve`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getScheduleReliability(details: {
		fromDate: string;
		toDate: string;
		laneID: string;
	}) {
		return this.http.post(
			`${this.domain}/analytics/getScheduleReliability`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCapacityData(details: { laneID: string; fromDate: string; toDate: string }) {
		return this.http.post(
			`${this.domain}/analytics/getCapacity`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getDetentionDemurrage(details: {
		fromDate: string;
		toDate: string;
		laneID: string;
		contractType: string;
		containerType: string;
	}) {
		return this.http.post(
			`${this.domain}/analytics/getDetentionDemurrage`,
			details,
			this.createAuthenticationHeaders()
		);
	}


	//#region Volume-Based Pricing (Add Volume card)

	// Persists the volume a customer moves on one lane, for one contract term
	// and one container type. Kept separate from saveLaneBenchmarkSettings/
	// getLaneBenchmarkSettings above — that pair belongs to the "Your
	// Benchmark" card (tier + the customer's own manually-entered rate).
	// The two features are independent and must not overwrite each other's
	// saved data for the same lane/unit.
	//
	// `term` is the storage key, not contractType + contractWithin: short term
	// and "Long term (All)" both carry contractWithin ['all'], so that pair
	// cannot tell them apart. The server keys on `term` for the same reason.
	saveVolumeBenchmarkSettings(details: {
		laneID: string;
		companyID: string;
		containerType: string;
		market: string[];
		contractType: string[];
		contractWithin: string[];
		term: string;
		monthlyVolume: number;
	}) {
		return this.http.post(
			`${this.domain}/analytics/saveVolumeBenchmarkSettings`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	// Reads back every saved volume for a lane, shaped
	// { term: { containerType: volume } }, so the popover's quick-switch chips
	// can show combinations the customer has not opened this session.
	getVolumeBenchmarkSettings(details: { laneID: string; companyID: string }) {
		return this.http.post(
			`${this.domain}/analytics/getVolumeBenchmarkSettings`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	// Account-level: the total volume the customer ships across every lane on a
	// mode, with the benchmark they are paying today and the one they are
	// aiming for. One record per mode — ocean counts containers per month, air
	// counts kilos. Drives the potential-savings figure on Market Pulse.
	saveAccountVolumeSettings(details: {
		laneType: 'ocean' | 'air';
		monthlyVolume: number;
		currentBenchmark?: string;
		targetBenchmark?: string;
		dataMode?: string;
	}) {
		return this.http.post(
			`${this.domain}/analytics/saveAccountVolumeSettings`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	// Returns both modes in one response — `{ ocean, air }`, either of which is
	// null when nothing has been saved for it yet — so the card can switch
	// between ocean and air without a second round trip.
	getAccountVolumeSettings(details: { dataMode?: string }) {
		return this.http.post(
			`${this.domain}/analytics/getAccountVolumeSettings`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion

	//#endregion Analytics

	//#region Plans
	getPlanDetails(payload: { planName: string }) {
		return this.http.post(
			`${this.domain}/plan/getPlans`,
			payload,
			this.createAuthenticationHeaders()
		);
	}

	getAllFeatureList(details) {
		return this.http.post(
			`${this.domain}/plan/getAllFeatureList`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	editPlan(details) {
		return this.http.post(
			`${this.domain}/plan/editPlan`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	addPlan(details) {
		return this.http.post(
			`${this.domain}/plan/addPlan`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion Plans

	//#region Port

	getPortDetails(details) {
		return this.http.post(
			`${this.domain}/port/getPortDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllPorts(details) {
		return this.http.post(
			`${this.domain}/port/getAllPorts`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion port

	//#region Exchange, Bunker & Jet
	getExchangeRates(details) {
		return this.http.post(
			`${this.domain}/analytics/getExchangeRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getFuelPrices(details) {
		return this.http.post(
			`${this.domain}/analytics/getFuelPrices`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getFuelPriceData(details) {
		return this.http.post(
			`${this.domain}/analytics/getFuelPriceData`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion Exchange, Bunker & Jet

	//#region lane

	addLanes(details) {
		return this.http.post(
			`${this.domain}/lane/addLanes`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllLanes(details) {
		return this.http.post(
			`${this.domain}/lane/getAllLanes`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	activateLane(details) {
		return this.http.post(
			`${this.domain}/lane/activateLane`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getLanesForUser(details) {
		return this.http.post(
			`${this.domain}/lane/getLanesForUser`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setSpotRateTrue(details) {
		return this.http.post(
			`${this.domain}/lane/setSpotRateTrue`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	updateLane(details) {
		return this.http.post(
			`${this.domain}/lane/updateLane`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	previewRates(details) {
		return this.http.post(
			`${this.domain}/lane/previewRates`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion lane

	//#region Extras
	getColorCodes(details) {
		return this.http.post(
			`${this.domain}extra/getColorCodes`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getTableColumns(details) {
		return this.http.post(
			`${this.domain}extra/getTableColumns`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setColor(details) {
		return this.http.post(
			`${this.domain}extra/setColor`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setNameForGeofence(details) {
		return this.http.post(
			`${this.domain}extra/setNameForGeofence`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getOfflineData(details) {
		return this.http.post(
			`${this.domain}extra/getOfflineData`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getMonitoringData(details) {
		return this.http.post(
			`${this.domain}extra/getMonitoringData`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getNotifications() {
		return this.http.post(
			`${this.domain}extra/getNotifications`,
			{},
			this.createAuthenticationHeaders()
		);
	}

	setReadStatusTrue(details) {
		return this.http.post(
			`${this.domain}extra/setReadStatusTrue`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getUpdateLogs(details) {
		return this.http.post(
			`${this.domain}extra/getUpdateLogs`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	payloadAnalytics(details) {
		return this.http.post(
			`${this.domain}extra/payloadAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getPayload(details) {
		return this.http.post(
			`${this.domain}extra/getPayload`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getUserPermission(details) {
		return this.http.post(
			`${this.domain}extra/getUserPermission`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	addWebAPI(details) {
		return this.http.post(
			`${this.domain}extra/addWebAPI`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getWebAPI(details) {
		return this.http.post(
			`${this.domain}extra/getWebAPI`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getGateOutReason(details) {
		return this.http.post(
			`${this.domain}extra/getGateOutReason`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCranesWiseAntennaDetails(details) {
		return this.http.post(
			`${this.domain}extra/getDeviceWiseAntennaDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion Extras

	//#region Reports
	getContainerMovements(details) {
		return this.http.post(
			`${this.domain}reports/getContainerMovements`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	gateReport(details) {
		return this.http.post(
			`${this.domain}reports/gateReport`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	inventoryReport(details) {
		return this.http.post(
			`${this.domain}reports/inventoryReport`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	machineMovementReport(details) {
		return this.http.post(
			`${this.domain}reports/machineMovementReport`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	areaWiseReport(details) {
		return this.http.post(
			`${this.domain}reports/areaWiseReport`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	scheduleReportEmail(details) {
		return this.http.post(
			`${this.domain}reports/scheduleReportEmail`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	//#endregion Reports
	addPlaceOnMap(details) {
		return this.http.post(
			`${this.domain}map/addPlaceOnMap`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	dynmaicReportsData(endpoint, details) {
		return this.http.post(
			`${this.domain}${endpoint}`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	getReportKeys(details) {
		return this.http.post(
			`${this.domain}reports/getReportKeys`,
			details,
			this.createAuthenticationHeaders()
		);
	}
	setDefaultKeys(details) {
		return this.http.post(
			`${this.domain}reports/setDefaultKeys`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	setLabel(details) {
		return this.http.post(
			`${this.domain}reports/setLabel`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	gateAnalytics(details) {
		return this.http.post(
			`${this.domain}analytics/gateAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	laneTypeAnalytics(details) {
		return this.http.post(
			`${this.domain}analytics/laneTypeAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCountOfEquipmentType(details) {
		return this.http.post(
			`${this.domain}analytics/getCountOfEquipmentType`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getTagAnalytics(details) {
		return this.http.post(
			`${this.domain}analytics/getTagAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAssetOnlineOffline(details) {
		return this.http.post(
			`${this.domain}analytics/getAssetOnlineOffline`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#region Buy Sell Price

	saveBuySellPrice(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/saveBuySellPrice`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAllBuySellPrices(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/getAllBuySellPrices`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	vendorCarrierMaster(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/vendorCarrierMaster`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getVendors(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/getVendors`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	deleteBuySellPrice(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/deleteBuySellPrice`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	updateBuySellPrice(details) {
		return this.http.post(
			`${this.domain}/buysellPrice/updateBuySellPrice`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#end region Buy Sell Price

	//#region Dashboard
	getTaskDetails(details) {
		return this.http.post(
			`${this.domain}dashboard/getTaskDetails`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getAvgMaxMoves(details) {
		return this.http.post(
			`${this.domain}dashboard/getAvgMaxMoves`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getRecentContainersBasedOnStatus(details) {
		return this.http.post(
			`${this.domain}dashboard/getRecentContainersBasedOnStatus`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCountOfContainersBasedOnStatus(details) {
		return this.http.post(
			`${this.domain}dashboard/getCountOfContainersBasedOnStatus`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getCountBasedOnProcessType(details) {
		return this.http.post(
			`${this.domain}dashboard/getCountBasedOnProcessType`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getContainerTypeAnalytics(details) {
		return this.http.post(
			`${this.domain}dashboard/getContainerTypeAnalytics`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	getTaskGraph(details) {
		return this.http.post(
			`${this.domain}dashboard/getTaskGraph`,
			details,
			this.createAuthenticationHeaders()
		);
	}

	//#endregion Dashboard

	// #region Alerts
	private sessionExpiredShown = false;
	error: (error: any) => void = (e) => {
		console.log(e);

		const { status, statusText, _body, message } = e;
		if (_body) {
			if (_body == 'Unauthorized') {
				console.log(this.sessionExpiredShown);

				if (!this.sessionExpiredShown) {
					this.sessionExpiredShown = true; // Prevent multiple alerts
					this.showToast('error', 'Session Expired! Please login again');
					this.logout();

					// Reset flag after a short delay to allow re-authentication attempts
					setTimeout(() => (this.sessionExpiredShown = false), 3000);
				}
			} else {
				console.log(_body);

				if (_body.type == 'error') {
					this.showToast('error', 'Connection Failed');
				} else {
					var err = JSON.parse(_body);
					this.showToast('error', err.message);
				}
			}
		} else {
			this.showToast(
				'error',
				'Try again later or Contact System Administrator'
			);
		}
	};

	alert(res, msg) {}

	alertWithMessage(res, msg, msgData) {
		// if (res.message == "No Token Provided" || res.message == "Token Invalid Error" || res.message.includes("Session Expired")) {
		//   swal.fire({
		//     title: 'Sorry!',
		//     text: "Sesion Expired.",
		//     icon: 'error',
		//     showCancelButton: false,
		//     allowOutsideClick: false,
		//     confirmButtonColor: '#3085d6',
		//     confirmButtonText: 'Login again'
		//   }).then((result) => {
		//     if (result.value) {
		//       authToken = null;
		//       window.location.reload();
		//       localStorage.removeItem('key');;
		//       this.router.navigate([''])
		//     }
		//   })
		// }
		// else {
		//   if (msg) {
		//     swal.fire('Sorry', msgData, 'error');
		//   }
		// }
	}

	showToast(type: String, message: String) {
		notifier.show(
			type.toUpperCase(),
			message,
			type.toLowerCase() == 'error' ? 'danger' : type.toLowerCase(),
			'',
			5000
		);
		if (
			message == 'No Token Provided' ||
			message == 'Token Invalid Error' ||
			message.includes('Session Expired')
		) {
			this.logout();
		}
	}

	base64Convert(files) {
		return new Promise((resolve, reject) => {
			var fr = new FileReader();
			fr.onload = () => {
				resolve(fr.result);
			};
			fr.onerror = (error) => {
				reject('Error: ' + error);
			};
			fr.readAsDataURL(files[0]);
		});
	}

	downloadImage(d, fileName) {
		fetch(d.image)
			.then((res) => res.blob())
			.then((blob) => {
				const file = new File([blob], d.ext);
				download(file, fileName, d.ext);
			});
	}

	detectFormChanges(form) {
		form.statusChanges.subscribe((validity) => {
			switch (validity) {
				case 'VALID':
					// do 'form valid' action
					break;
				case 'INVALID':
					formValidity();
					break;
			}

			formValidity();
		});
	}

	resetVormValidity(form) {
		resetVormValidity();
	}
	// #endregion Alerts

	// socket: Socket;
	// observer: Observer<any>;
	// getSocketData() : Observable<any>
	// {
	//   this.socket = socketIo();

	//   this.socket.on('data', (res) =>
	//   {
	//     this.observer.next(res.data);
	//   });

	//   return this.createObservable();
	// }

	// createObservable() : Observable<number>
	// {
	//     return new Observable<number>(observer =>
	//     {
	//       this.observer = observer;
	//     });
	// }

	// private handleError(error) {
	//   console.error('server error:', error);
	//   if (error.error instanceof Error) {
	//       let errMessage = error.error.message;
	//       return Observable.throw(errMessage);
	//   }
	//   return Observable.throw(error || 'Socket.io server error');
	// }
}

function formValidity() {
	var forms = document.getElementsByClassName('needs-validation');
	Array.prototype.filter.call(forms, function (form) {
		form.classList.add('was-validated');
	});
}

function resetVormValidity() {
	var forms = document.getElementsByClassName('needs-validation');
	Array.prototype.filter.call(forms, function (form) {
		form.classList.remove('was-validated');
	});
}

function jqueryFns() {
	$(document).ready(function () {
		// App.init();
	});
}
